<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading page-heading">
          <div>
            <h2>Lista pomysłów KaiZen</h2>
          </div>
        </div>

        <div class="widget-content">
          <section>
            <div class="toolbar">
			<select class="form-select form-sm mb-2" style="width: 140px;" v-model="selectedYear" @change="onYearChange">
				<option v-for="year in availableYears" :key="year" :value="year">
				  {{ year }}
				</option>
			  </select>
              <div class="search-box">
                <span class="search-icon">⌕</span>
                <input v-model="search" type="search" placeholder="Szukaj ..."
                  aria-label="Szukaj wniosków" @input="onSearchInput" />
              </div>
            </div>

            <div class="list-meta">
              <span>
                <span class="online-dot"></span>
                Sortowanie: od najnowszych
              </span>

              <span v-if="wnioski.total">
                Wyświetlanie {{ wnioski.from }}–{{ wnioski.to }}
                z {{ wnioski.total }}
              </span>
            </div>

            <div v-if="pageError" class="notice notice-error" role="alert">
              {{ pageError }}
              <button type="button" @click="pageError = ''">×</button>
            </div>

            <div v-if="pageSuccess" class="notice notice-success" role="status">
              {{ pageSuccess }}
              <button type="button" @click="pageSuccess = ''">×</button>
            </div>

            <div v-if="records.length" class="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Numer</th>
                    <th>Temat</th>
                    <th>Obszar</th>
                    <th>Autor</th>
                    <th>Data dodania</th>
                    <th>Status</th>
					<th>Pliki</th>
                    <th>Oddaj głos</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="record in records" :key="record.id">
                    <td style="min-width: 80px;max-width:100px;">
                      {{ record.numer }}
                    </td>
                    <td>
                      {{ record.temat }}
                    </td>
                    <td>
                      {{ record.obszar || "—" }}
                    </td>

                    <td style="min-width: 80px;max-width:100px;">
                      {{ authorName(record.user) }}
                    </td>
                    <td style="min-width: 80px;max-width:100px;">
                      {{ formatDate(record.created_at) }}
                    </td>
                    <td style="max-width:80px;">
                      <span :class="['status', statusClass(record.status)]">
                        <span class="status-dot"></span>
                        {{ statusLabel(record.status) }}
                      </span>
                    </td>
					<td class="files-cell">
					  <div v-if="record.files && record.files.length" class="file-list">
						<div
						  v-for="file in record.files"
						  :key="file.id"
						  class="file-item"
						>
						  <a
							class="file-link"
							:href="route('kaizen.files.download', {
							  kaizen: record.id,
							  file: file.id
							})"
						  >
							{{ file.name }}
						  </a>
						</div>
					  </div>
					  <span v-else class="no-files">Brak plików</span>
					</td>					
                    <td class="vote-cell" style="min-width: 80px;max-width:150px;">
                      <template v-if="currentVote(record)">
                        <div class="voted-state">
                          <span class="voted-check">✓</span>

                          <span>
                            <strong>
                              {{ voteLabel(currentVote(record)) }}
                            </strong>
                          </span>
                        </div>
                      </template>

                      <template v-else>
                        <div class="vote-options">
                          <button type="button" class="vote-button vote-yes" :disabled="votingId !== null"
                            @click="castVote(record, 'tak')">
                            {{ votingId === record.id ? "..." : "Tak" }}
                          </button>

                          <button type="button" class="vote-button vote-no" :disabled="votingId !== null"
                            @click="castVote(record, 'nie')">
                            Nie
                          </button>

                          <button type="button" class="vote-button vote-unknown" :disabled="votingId !== null"
                            @click="castVote(record, 'nie_wiem')">
                            Nie wiem
                          </button>
                        </div>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-else class="empty-state">
              <div class="empty-icon">⌕</div>

              <strong>Nie znaleziono wniosków</strong>

              <p>
                {{ search
                  ? "Zmień frazę wyszukiwania i spróbuj ponownie."
                  : "Nie ma jeszcze wniosków do wyświetlenia." }}
              </p>

              <button v-if="search" type="button" class="btn-outline" @click="clearSearch">
                Wyczyść wyszukiwanie
              </button>
            </div>

            <div v-if="paginationLinks.length > 3" class="pagination-footer">
              <span class="pagination-info">
                Strona {{ wnioski.current_page }} z {{ wnioski.last_page }}
              </span>

              <nav aria-label="Paginacja wniosków">
                <ul class="pagination">
                  <li v-for="(link, index) in paginationLinks" :key="`${index}-${link.label}`" :class="{
                    active: link.active,
                    disabled: !link.url,
                  }">
                    <button type="button" class="page-link" :disabled="!link.url"
                      :aria-current="link.active ? 'page' : undefined" @click="goToPage(link.url)"
                      v-html="link.label"></button>
                  </li>
                </ul>
              </nav>
            </div>
          </section>
        </div>
      </div>

    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import axios from "axios";
import { router } from "@inertiajs/vue3";

export default {
  name: "KaiZenList",

  components: {
    AppLayout,
  },

  props: {
    wnioski: {
      type: Object,
      default: () => ({
        data: [],
        links: [],
        total: 0,
        current_page: 1,
        last_page: 1,
      }),
    },
availableYears: {
  type: Array,
  default: () => [new Date().getFullYear()],
},
    filters: {
      type: Object,
      default: () => ({ search: "" }),
    },

    statusy: {
      type: Object,
      default: () => ({
        0: "Nowy",
        1: "W trakcie",
        2: "Zrealizowano",
        3: "Odrzucony",
      }),
    },
  },

  data() {
    return {
      search: this.filters.search || "",
      votingId: null,
	  selectedYear: Number(
  this.filters.year || new Date().getFullYear()
),
      pageError: "",
      pageSuccess: "",
      searchTimer: null,
      localVotes: {},
      localCounts: {},
    };
  },

  computed: {
    records() {
      return this.wnioski?.data || [];
    },

    paginationLinks() {
      return this.wnioski?.links || [];
    },
  },

  watch: {
"filters.year"(value) {
  this.selectedYear = Number(
    value || new Date().getFullYear()
  );
},
  },

  beforeUnmount() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  },

  methods: {
  submitFilters(page = 1) {
  if (this.searchTimer) {
    clearTimeout(this.searchTimer);
  }

  router.post(
    route("kaizen.list"),
    {
      year: this.selectedYear,
      search: this.search.trim(),
      page,
    },
    {
      preserveState: true,
      preserveScroll: true,
      replace: true,
    }
  );
},

onYearChange() {
  this.pageError = "";
  this.pageSuccess = "";
  this.submitFilters(1);
},
    authorName(user) {
      if (user.name) return user.name;

      const first = user.first_name || "";
      const last = user.last_name || "";

      return `${first} ${last}`.trim();
    },

    statusLabel(status) {
      return (
        this.statusy?.[Number(status)] ??
        this.statusy?.[String(status)] ??
        "Nieznany"
      );
    },

    statusClass(status) {
      return {
        0: "status-new",
        1: "status-progress",
        2: "status-done",
        3: "status-rejected",
      }[Number(status)] || "status-default";
    },

    currentVote(record) {
      if (
        Object.prototype.hasOwnProperty.call(this.localVotes, record.id)
      ) {
        return this.localVotes[record.id];
      }

      return record.votes?.[0]?.vote || null;
    },

    voteCount(record) {
      if (
        Object.prototype.hasOwnProperty.call(this.localCounts, record.id)
      ) {
        return this.localCounts[record.id];
      }

      return Number(record.votes_count || 0);
    },

    voteLabel(vote) {
      return {
        tak: "Tak",
        nie: "Nie",
        nie_wiem: "Nie wiem",
      }[vote] || vote;
    },

onSearchInput() {
  if (this.searchTimer) {
    clearTimeout(this.searchTimer);
  }

  this.searchTimer = setTimeout(() => {
    this.submitFilters(1);
  }, 350);
},

clearSearch() {
  this.search = "";
  this.submitFilters(1);
},

goToPage(url) {
  if (!url) return;

  const parsedUrl = new URL(url, window.location.origin);
  const page = Number(parsedUrl.searchParams.get("page") || 1);

  this.submitFilters(page);
},

	async castVote(record, vote) {
	  if (this.votingId !== null || this.currentVote(record)) {
		return;
	  }

	  this.votingId = record.id;
	  this.pageError = "";
	  this.pageSuccess = "";

	  try {
		const response = await axios.post(
		  route("kaizen.vote.store", record.id),
		  { vote },
		  {
			headers: {
			  Accept: "application/json",
			},
		  }
		);

		// Zapisz głos użytkownika.
		this.localVotes = {
		  ...this.localVotes,
		  [record.id]: response.data.vote.vote,
		};

		// Zaktualizuj liczbę głosów.
		this.localCounts = {
		  ...this.localCounts,
		  [record.id]: Number(response.data.votes_count || 0),
		};

		// Zaktualizuj status bez przeładowania tabeli.
		if (
		  Number(record.status) === 0 &&
		  response.data.status !== undefined
		) {
		  record.status = Number(response.data.status);
		} else if (Number(record.status) === 0) {
		  // Zgodność ze starszą odpowiedzią backendu.
		  record.status = 1;
		}

		this.pageSuccess =
		  response.data.message || "Głos został zapisany.";
	  } catch (error) {
		if (error.response?.status === 409) {
		  this.pageError =
			error.response.data?.message ||
			"Na ten wniosek oddano już głos.";
		} else if (error.response?.status === 422) {
		  this.pageError =
			"Nieprawidłowa odpowiedź. Wybierz Tak, Nie lub Nie wiem.";
		} else if (error.response?.status === 401) {
		  this.pageError = "Sesja wygasła. Zaloguj się ponownie.";
		} else if (error.response?.status === 403) {
		  this.pageError = "Nie masz uprawnień do głosowania.";
		} else {
		  this.pageError =
			error.response?.data?.message ||
			"Nie udało się zapisać głosu. Odśwież stronę i sprawdź wynik przed ponowną próbą.";
		}
	  } finally {
		this.votingId = null;
	  }
	},

    formatDate(value) {
      if (!value) return "—";

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "—";

      return new Intl.DateTimeFormat("pl-PL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }).format(date);
    },
  },
};
</script>


<style scoped>
.page-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
  padding: 10px 0 24px;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  padding: 20px 0 14px;
}

.section-heading {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.total-badge {
  padding: 6px 10px;
  border-radius: 20px;
  background: #edf4ff;
}

.search-box {
  display: flex;
  width: min(100%, 440px);
  min-height: 42px;
  align-items: center;
  gap: 9px;
  padding: 0 11px;
  border: 1px solid #dfe6ef;
  border-radius: 9px;
  background: #fff;
  box-sizing: border-box;
}

.search-box:focus-within {
  border-color: #7da4f5;
  box-shadow: 0 0 0 3px rgb(40 100 215 / 9%);
}

.search-icon {
  flex: 0 0 auto;
}

.search-box input {
  width: 100%;
  min-width: 0;
  padding: 10px 0;
  border: 0;
  outline: 0;
  background: transparent;
  box-sizing: border-box;
}

.list-meta {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  padding: 4px 0 15px;
}

.online-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  margin-right: 6px;
  border-radius: 50%;
  background: #26a269;
}

/* Tabela */
.table-wrap {
  width: 100%;
  overflow-x: auto;
  border: 1px solid #e8edf3;
  border-radius: 10px;
  -webkit-overflow-scrolling: touch;
}

table {
  width: 100%;
  min-width: 900px;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  text-align: left;
}

th,
td {
  padding: 12px;
  border-bottom: 1px solid #edf0f5;
  vertical-align: middle;
  letter-spacing: normal;
  text-transform: none;
}

th {
  background: #f7f9fc;
  white-space: nowrap;
}

tbody tr:last-child td {
  border-bottom: 0;
}

tbody tr {
  transition: background 0.15s;
}

tbody tr:hover {
  background: #fafcff;
}

.status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 9px;
  border-radius: 20px;
  white-space: nowrap;
}

.status-dot {
  width: 6px;
  height: 6px;
  flex: 0 0 6px;
  border-radius: 50%;
  background: currentColor;
}

.status-new {
  background: #eaf1ff;
  color: #2457c5;
}

.status-progress {
  background: #fff3d9;
  color: #996100;
}

.status-done {
  background: #e4f7ee;
  color: #168258;
}

.status-rejected {
  background: #ffebeb;
  color: #c23939;
}

.status-default {
  background: #edf0f5;
  color: #596579;
}

.date-cell {
  min-width: 125px;
  white-space: nowrap;
}

.vote-count {
  display: block;
}

.vote-count-label {
  display: block;
  margin-top: 3px;
}

.vote-cell {
  min-width: 210px;
}

.vote-options {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.vote-button {
  padding: 7px 9px;
  border: 1px solid transparent;
  border-radius: 7px;
  background: #fff;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.vote-button:disabled {
  cursor: wait;
  opacity: 0.55;
}

.vote-yes {
  border-color: #b7e5ce;
  background: #f0fbf5;
  color: #168258;
}

.vote-yes:hover:not(:disabled) {
  border-color: #168258;
  background: #e2f7ec;
}

.vote-no {
  border-color: #f0c4c4;
  background: #fff5f5;
  color: #c23939;
}

.vote-no:hover:not(:disabled) {
  border-color: #c23939;
  background: #ffebeb;
}

.vote-unknown {
  border-color: #d8deea;
  background: #f7f8fb;
  color: #596579;
}

.vote-unknown:hover:not(:disabled) {
  border-color: #8795ac;
  background: #edf1f7;
}

.vote-hint {
  display: block;
  margin-top: 6px;
}

.voted-state {
  display: flex;
  align-items: center;
  gap: 8px;
}

.voted-check {
  display: flex;
  width: 25px;
  height: 25px;
  flex: 0 0 25px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #e4f7ee;
}

.voted-state strong {
  display: block;
}

.voted-state small {
  display: block;
  margin-top: 3px;
}

.notice {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 14px;
  padding: 12px 14px;
  border: 1px solid transparent;
  border-radius: 8px;
}

.notice button {
  border: 0;
  background: transparent;
  cursor: pointer;
}

.notice-error {
  border-color: #f0c7c7;
  background: #fff3f3;
  color: #a92f2f;
}

.notice-success {
  border-color: #bde8d0;
  background: #effaf4;
  color: #176c49;
}

.empty-state {
  margin-top: 15px;
  padding: 45px 15px;
  border: 1px dashed #dfe6ef;
  border-radius: 10px;
  text-align: center;
}

.empty-icon {
  margin-bottom: 10px;
}

.empty-state strong {
  display: block;
}

.empty-state p {
  margin: 7px 0 15px;
}

.btn-outline {
  padding: 8px 12px;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
  background: #fff;
  cursor: pointer;
}

.pagination-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 14px;
  padding: 18px 4px 4px;
}

.pagination {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.page-link {
  display: inline-flex;
  min-width: 34px;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
  background: #fff;
  cursor: pointer;
}

.pagination li.active .page-link {
  border-color: #2864d7;
  background: #2864d7;
  color: #fff;
}

.pagination li.disabled .page-link {
  background: #f7f8fa;
  color: #aab3c0;
  cursor: not-allowed;
}

.page-footnote {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 15px;
}

.info-icon {
  display: inline-flex;
  width: 17px;
  height: 17px;
  flex: 0 0 17px;
  align-items: center;
  justify-content: center;
  border: 1px solid #aab5c5;
  border-radius: 50%;
}

@media (max-width: 768px) {
  .page-heading {
    align-items: flex-start;
  }

  .toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .search-box {
    width: 100%;
  }

  .list-meta {
    flex-direction: column;
  }

  .pagination-footer {
    align-items: flex-start;
    flex-direction: column;
  }
}
.files-cell {
  min-width: 180px;
  max-width: 280px;
}

.file-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 7px;
  margin-bottom: 10px;
}

.file-link {
  display: inline-flex;
  align-items: flex-start;
  gap: 6px;
  color: #2864d7;
  font-size: 12px;
  text-decoration: none;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.file-link:hover {
  text-decoration: underline;
}

.no-files {
  display: block;
  margin-bottom: 10px;
  color: #8793a5;
  font-size: 12px;
}

</style>
